import { render, staticRenderFns } from "./DashboardAnalytics.vue?vue&type=template&id=79536e0c&"
import script from "./DashboardAnalytics.vue?vue&type=script&lang=js&"
export * from "./DashboardAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAnalytics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79536e0c')) {
      api.createRecord('79536e0c', component.options)
    } else {
      api.reload('79536e0c', component.options)
    }
    module.hot.accept("./DashboardAnalytics.vue?vue&type=template&id=79536e0c&", function () {
      api.rerender('79536e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DashboardAnalytics.vue"
export default component.exports